import axios from 'axios'
import {apiToUpload} from './converters'

const API_V1_URL = process.env.API_V1_URL

export default {
  uploadCSV(csv) {
    return axios.post(API_V1_URL + '/tx/bulk', csv)
      .then(res => res.data)
  },
  getRecentUploadsSummary(offset = 0, limit = 20) {
    return axios.get(API_V1_URL + '/operations?offset=' + offset + '&limit=' + limit)
      .then(res => res.data.map(apiToUpload))
  },
}



// WEBPACK FOOTER //
// ./src/-service-app/services/uploadService.js